import { useQuery } from '@apollo/client';
import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import { AccountClient } from '@nile/graphql';
import {
  GET_ROLES,
  GET_ROLES_TYPE_DETAIL,
  GET_ROLE_PERMISSON
} from '@nile/banyan/src/Graphql/Mutations/role';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import { PageContent } from '@nile/banyan/src/Utils/style';
import {
  getTranslatedText,
  AccessControl,
  CascadeCard,
  DeleteModal,
  Loader
} from '@nile/components';
import {
  Button,
  ButtonGroup,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { groupBy } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

function RenderPermissions(props) {
  const { module, feature, availableRoleFeatureList } = props;
  let featureToCompare = availableRoleFeatureList[module].find(
    (el) => el.feature.featureId === feature.feature.featureId
  );
  if (!featureToCompare) return '';

  return (
    <div className="fx actr">
      {featureToCompare.operationList.map((op, idx) => {
        return (
          <div className="flex center">
            <div
              className={`ml8 ${
                feature.operationList.find(
                  (el) => el.operationId === op.operationId
                )
                  ? ''
                  : 'disabled'
              }`}
            >
              <FormattedMessage id={op?.labelKey ?? op?.name} />
            </div>
            {idx !== featureToCompare.operationList.length - 1 ? (
              <div className="dot-separator" />
            ) : (
              ''
            )}
          </div>
        );
      })}
    </div>
  );
}

function RoleInformationView(props) {
  const { intl, allRoles } = props;
  let { roleId } = props.role;

  const { loading: loadingRoleDetail, data: roleTypes } = useQuery(
    GET_ROLES_TYPE_DETAIL,
    {
      client: AccountClient,
      fetchPolicy: 'network-only'
    }
  );
  const {
    loading: loadingPermisson,
    error: errorPermission,
    data: rolePermission
  } = useQuery(GET_ROLE_PERMISSON, {
    variables: { roleId },
    client: AccountClient,
    fetchPolicy: 'network-only'
  });

  if (loadingRoleDetail || loadingPermisson) return <Loader />;
  if (errorPermission) return <p>{errorPermission.message}</p>;
  const currentRole = allRoles.find((el) => el.roleId === roleId);
  const currentRoleType = roleTypes.getRoleTypeDetails.find(
    (el) => el.roleTypeId === currentRole.roleType.roleTypeId
  );
  const currentRoleFeatureList = currentRoleType.roleTypeFeatureList;
  const roleFeatureList = rolePermission.getRolePermissions.roleFeatureList
    .map((item) => {
      const obj = {
        ...item,
        feature:
          currentRoleFeatureList.find(
            (el) => el.feature.featureId === item.feature.featureId
          )?.feature || null
      };
      if (obj.feature) return obj;
      return null;
    })
    .filter((el) => !!el);
  const roles = {
    ...currentRole,
    roleType: {
      value: currentRole.roleType.roleTypeId
    },
    roleFeatureList: roleFeatureList,
    addUserList: [],
    deleteUserList: []
  };
  const roleTypeDetail = roleTypes.getRoleTypeDetails;

  const { roleType } = roles;
  const rawFeatureList = roleTypeDetail.find(
    (el) => el.roleTypeId === roleType.value
  ).roleTypeFeatureList;
  const availableRoleFeatureList = groupBy(rawFeatureList, (el) => {
    return el.feature.permissionCategory.permissionCategoryId;
  });
  const selectedRoleFeatureList = roleFeatureList.length
    ? groupBy(roleFeatureList, (el) => {
        return el.feature.permissionCategory.permissionCategoryId;
      })
    : (function() {
        let initSelection = {};
        for (var prop in availableRoleFeatureList) {
          initSelection[prop] = availableRoleFeatureList[prop].map((ft) => {
            return {
              ...ft,
              operationList: []
            };
          });
        }
        return initSelection;
      })();

  const featureOptions = Object.keys(selectedRoleFeatureList).map((module) => {
    return (
      <div className="mb40">
        <div className="flex mb10">
          <Heading element="h4" weight="Bold">
            <FormattedMessage
              id={
                selectedRoleFeatureList[module][0].feature.permissionCategory
                  ?.labelKey
              }
            />
          </Heading>
        </div>

        {selectedRoleFeatureList[module].map((feature) => {
          return (
            <div className="flex mr8 mb10 Role-Name ml-0">
              <div
                className={`w50 ${
                  feature.operationList.length ? '' : 'disabled'
                }`}
              >
                <FormattedMessage
                  id={feature?.feature?.labelKey ?? feature?.feature?.name}
                />
              </div>
              <RenderPermissions
                availableRoleFeatureList={availableRoleFeatureList}
                module={module}
                feature={feature}
              />
            </div>
          );
        })}
      </div>
    );
  });

  const deleteRole = (roleId) => {
    props.deleteRole(roleId);
  };
  return (
    <>
      <div className="pr-5 fx mt25 mb25 ml-10 mr10">
        <div className="fx2 Main-Heading ">
          <Heading element="h2">{props.role.name}</Heading>
          <p className="wm-700 mt8">{props.role.description || ''}</p>
        </div>
        <div data-qa="editBtn" className="fx jend actr Role-Btn-Group">
          <ButtonGroup>
            {props.role.creationType !== 'System' && (
              <div superid="delete-role">
                <AccessControl
                  roleToCheck="role.delete"
                  render={
                    <DeleteModal
                      id="deleteRole"
                      description={getTranslatedText(
                        intl,
                        'admin.Technicianrole.delete.query'
                      )}
                      handleDeleteConfirmation={() =>
                        deleteRole(props.role.roleId)
                      }
                      title={getTranslatedText(
                        intl,
                        'admin.Technicianrole.delete'
                      )}
                    />
                  }
                />
              </div>
            )}
            {props.role.editable && (
              <div superid="edit-role">
                <AccessControl
                  roleToCheck="role.edit"
                  render={
                    <Button
                      secondary
                      icon={<SVGIcon name="Edit" />}
                      url={
                        '#/onboard/roles/' +
                        props.page +
                        '/' +
                        props.role.roleId +
                        '/edit'
                      }
                    />
                  }
                />
              </div>
            )}
          </ButtonGroup>
        </div>
      </div>
      <div className="scroll pl10">{featureOptions}</div>
    </>
  );
}

class RolesCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      selectedRole: props?.roles?.[0],
      selectedItems: props.roles.length > 0 ? [props.roles[0].roleId] : [],
      uioptions: [
        {
          id: 1,
          name: '',
          uioptions: props.roles
        }
      ]
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      !props.roles.find((role) => role.roleId === state.selectedRole.roleId)
    ) {
      return {
        ...state,
        selectedRole: props?.roles?.[0],
        selectedItems: [props?.roles?.[0]?.roleId]
      };
    }
  }

  componentDidMount() {
    if (this.props.roles.length > 0) {
      this.renderSubItem(this.props.roles[0]);
    }
  }

  componentDidCatch(e) {
    this.setState({ hasError: true });
  }

  renderSubItem = (item) => {
    this.setState({
      selectedRole: {
        roleId: item.roleId,
        name: item.name,
        description: item.description,
        roleType: item.roleType,
        editable: item.editable,
        creationType: item.creationType
      }
    });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ hasError: false });
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
      const item = this.props.roles.find(
        (el) => el.roleId === selectedItem[selectedItem.length - 1]
      );
      this.renderSubItem(item);
    }
  };

  deleteRole = (roleId) => {
    this.props.deleteRole({
      variables: { roleId }
    });
  };

  handleRoleChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { selectedRole, selectedItems, hasError } = this.state;

    const { intl, page } = this.props;

    const allRoles = this.props.roles;
    const roles = allRoles.map((el) => {
      return {
        ...el,
        id: el.roleId
      };
    });
    const processedAllItems = processData(roles, 'roleId');
    return (
      <div className="white-transparent-bg sops-remove-height no-scroll fh">
        <div className="fx full-width ch-20">
          <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
            <div className="full-width">
              <div className="sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleRoleChange}
                />
              </div>
              <div className="cascade-list pt10 ch-50">
                <ResourceList
                  resourceName={{ singular: 'customer', plural: 'customers' }}
                  items={roles}
                  selectedItems={selectedItems}
                  onSelectionChange={this.setSelectedItems}
                  renderItem={(item, index) => {
                    const { id, name, technicians, clients } = item;
                    return (
                      <ResourceItem
                        id={item.roleId}
                        key={item.roleId}
                        accessibilityLabel={`View details for ${name}`}
                        customClassName="list-no-pad"
                      >
                        <div
                          className="fw list-item pl-4"
                          superid="roles-list-item"
                        >
                          {!technicians && !clients && (
                            <TextStyle variation="strong">{name} </TextStyle>
                          )}
                        </div>
                        {item.uioptions && item.uioptions.length > 0 ? (
                          <div className="iconHolder">
                            <SVGIcon name="ArrowRight" />
                          </div>
                        ) : (
                          <></>
                        )}
                      </ResourceItem>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          {!hasError && selectedRole && (
            <div className="fx col scroll w70 white-transparent-bg p2040 pr0">
              <RoleInformationView
                intl={intl}
                roleTypeDetail={this.props.roleTypeDetail}
                role={selectedRole}
                deleteRole={this.deleteRole}
                page={page}
                allRoles={allRoles}
              />
            </div>
          )}
          {hasError ? <div>Something went wrong...</div> : ''}
        </div>
      </div>
    );
  }
}

export default injectIntl(RolesCascade);
